import { render, staticRenderFns } from "./ActionBlock.vue?vue&type=template&id=caf51220&scoped=true&"
import script from "./ActionBlock.vue?vue&type=script&lang=js&"
export * from "./ActionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf51220",
  null
  
)

export default component.exports